export class Filters {
    constructor() {
        this.setProperties();
        this.setEvents();
    }

    setProperties () {
        this.$form = $( '.filters-wrapper' );
        this.$fields = this.$form.find( 'input, select' );
        this.$boxes = this.$form.find( '.filter-box-button' );
        this.$clear = this.$form.find( '.clear-filters-wrapper' );
    }

    setEvents () {
        this.$fields.on( 'change', () => {
            this.$form.submit();
        } );

        this.$boxes.on( 'click', function () {
            $( this ).siblings( 'input' ).trigger( 'click' );
        } );

        if ( 0 !== this.$form.find( 'input[type=checkbox]:checked').length || '0' !== this.$form.find( 'select' ).val() ) {
            this.$clear.addClass( 'active' );
        }
    }
}
